export default () => ({
  nombre: "",
  token: "",
});
